import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.SubmitJob = {
  displayName: 'SubmitJob',
  errorMessage: '',

  component: React.createClass({
    getInitialState: function() {
      return {
        hasJobs: false
      }
    },

    componentDidMount: function() {
      this.createJob()
    },

    fetchJobClosureData: function() {
      let job_closure_data = SS.API.V3.jobClosureDataGet()

      $.ajax(job_closure_data).done((data) => {
        if(typeof data.job !== 'undefined'){
          this.setState({
            hasJobs: true
          })

          let survery_data = {
            job: data.job,
            possibleBusinesses: data.possible_businesses,
            outcome: data.outcome,
            providerAccountId: data.provider_account ? data.provider_account.id : null,
            providerAccountName: data.provider_account ? data.provider_account.business_name: null,
            rating: null,
            comments: null,
            selectedReasons: [],
            value: data.amountPaid
          }

          Job.Actions.updateClosureSurvey(survery_data)
        }
      }).fail((data) => { document.location = '/500' })
    },

    createUser: function() {
      let subscribeToMessages = true

      var userObj = SS.API.V3.userCreate(
        {
          email: Job.Data.emailAddress,
          name: Job.Data.firstName,
          phone: Job.Data.phoneNumber,
          'autogenerate-password': true
        },
        {
          type: 'email-preferences',
          attrs: {
            'ss-update': subscribeToMessages,
            'sms-offers': subscribeToMessages
          }
        });

      $.ajax(userObj)
        .done((data) => {
          $('#user-session-id').attr('title', data.data.id)
          SS.currentUserId = data.data.id;
          SS.userPhoneIsValid = data.meta.validPhone

          if (SS.appFn.userHasValidPhone() == true) {
            //StepSequence.removeStepByType(Contact)
          }

          this.createJob()
        })
        .fail((data) => {
          if (data.status === 422) {
            let res = data.responseJSON
            for (let i = 0; i < res.errors.length; i++) {
              this.errorMessage = this.errorMessage += ' ' + res.errors[i].detail
            }
          } else {
            this.errorMessage = 'Sorry we are unable to process your request at this time. Please try again later.'
            document.location.href = '/500'
          }
        })
    },

    createJob: function() {
      let job = Job.Data;
      const $modalFooter = $('#job-modal').find('.modal-footer')

      $modalFooter.hide()

      var subcats = []
      for (var j = 0; j < job.categories.length; j++) {
        subcats[j] = { type: 'subcategories',
                       id: job.categories[j].id }
      }

      var jobCreateData = {
        data: {
          type: 'jobs',
          attributes: {
            description: buildDescription(),
            starting:    job.schedule.replace(/_/g, ' '),
            budget:      job.minBudget,
            min_budget:  job.minBudget,
            max_budget:  job.maxBudget,
            can_call:    job.canCall,
            schedule:    buildJobSchedule(),
            preferred_outcome: job.preferredOutcome,
            interested_in_best_pro: job.interestedInBestPro,
            contact_preference: job.contactPreference,
            disable_processing: false
          },
          relationships: {
            suburb: {
              data: {
                type: 'suburbs',
                id: job.suburb_id
              }
            },
            'job-subcategories': {
              data: subcats
            },
            'exclusive-to-business': {
              data: {
                type: 'businesses',
                id: Job.Data.exclusiveFor
              }
            }
          }
        },
        'included': [
          {
            'type': 'alliance-partners',
            'attributes': { 'name': job.originName }
          },
          {
            'type': 'job-referrers',
            'attributes': Job.Data.referrer
          },
          {
            'type': 'tracking-data',
            'attributes': {
              'creative':     decodeURI(Cookies.get('creative')),
              'keyword':      decodeURI(Cookies.get('keyword')),
              'matchtype':    decodeURI(Cookies.get('matchtype')),
              'adposition':   decodeURI(Cookies.get('adposition')),
              'campaignid':   decodeURI(Cookies.get('campaignid')),
              'adgroupid':    decodeURI(Cookies.get('adgroupid')),
              'geo':          decodeURI(Cookies.get('geo')),
              'utm_campaign': decodeURI(Cookies.get('utm_campaign')),
              'utm_source':   decodeURI(Cookies.get('utm_source')),
              'utm_medium':   decodeURI(Cookies.get('utm_medium')),
              'utm_content':  decodeURI(Cookies.get('utm_content')),
              'gclid':        decodeURI(Cookies.get('gclid'))
            }
          }
        ]
      }

      $.ajax(SS.API.V3.jobCreate(jobCreateData))
        .done((createdJson) => {
          Job.PostingProgressActions.updateTracking({ jobId: createdJson.data.id })
          Job.Data.id = createdJson.data.id
          let creditCard = createdJson.data.attributes.creditCard
          if (creditCard) {
            Job.Data.with_cc   = true
            Job.Data.cc_number = creditCard.number
          }
          SS.appFn.appMsg({ id: createdJson.data.id }) // used by mobile app for controlling the flow
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ event: 'custom.event.submitJob' });
          this.fetchJobClosureData()

          if(job.attachments.length) {
            uploadFilesToJob(createdJson.data.id)
          } else {
            var slideTo = '';
            if(this.state.hasJobs) {
              slideTo = JobWizardMobile.HasJobBeenDoneYet;
            }

            if (slideTo === '') {
              redirectToJobPage()
            }
            else {
              JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', slideTo)
            }
          }
        })
        .fail(() => {
          document.location.href = '/500'
        })

      function buildJobSchedule() {
        if (job.schedule !== 'on_a_particular_date') { return "" }

        var [day, month, year] = job.scheduleDate.split("/")

        return new Date([year, month, day])
      }

      function buildDescription() {
        const job = Job.Data;

        let description = `${job.description}`

        if (job.extraDetails) {
          buildExtraDetails()
        }

        switch(job.schedule) {
        case 'flexible':
          description += '\n\nSchedule: I’m flexible\n\n';
          break;
        case 'next_couple_of_weeks':
          description += '\n\nSchedule: Need job done in the next few weeks\n\n';
          break;
        case 'on_a_particular_date':
          description += `\n\nSchedule: Need job done on ${job.scheduleDate}\n\n`
          break;
        case 'asap_urgent':
          description += '\n\nSchedule: Need job done urgently\n\n'
          break;
        default:
          description += '\n\nSchedule: Not Specified\n\n';
        }

        if (job.budget === 'yes') {
          description += `\nBudget: ${SS.appFn.stringUtils.capitalise(job.budgetType)}`
        }
        else if (job.budgetType !== 'price_range' && job.budgetType !== 'set_price') {
          description += `\nBudget: Not Specified`
        }

        if (job.budgetType === 'price_range' && job.budgetPriceRange !== null) {
          if (job.minBudget == '5001' && job.maxBudget == '5001') {
            description += `\nBudget: More than $5000`
          } else {
            description += `\nBudget: $${job.minBudget} - $${job.maxBudget}`
          }
        }

        if (job.budgetType === 'set_price' && job.budgetSetPriceRange !== null) {
          let price = job.budgetSetPriceRange
          description += `\nBudget: $${price}`
        }

        if (job.siteVisit !== null)
        {
          let siteVisit = SS.appFn.stringUtils.capitalise(job.siteVisit.replace(/_/g, ' '))
          description += `\n\nSite Visit: ${siteVisit}`

          if (job.siteVisitTime !== null) {
            description += `\nSite Visit: ${SS.appFn.stringUtils.capitalise(job.siteVisitTime)}`
          }
        }

        function buildExtraDetails() {
          description += '\n\n\nSpecific Job Details: \n'
          formatExtraDetails()

          function formatExtraDetails() {
            Object.keys(job.extraDetails).forEach(function(descriptionKey) {
              if(Array.isArray(job.extraDetails[descriptionKey])) {
                description += `\n ${descriptionKey}: \n${addLeadingHyphens(descriptionKey)} \n`
              } else {
                description += `\n ${descriptionKey}: ${job.extraDetails[descriptionKey]} \n`
              }
            })
          }

          function addLeadingHyphens(key) {
            return job.extraDetails[key].map((el) => '  - ' + el).join('\n')
          }
        }

        return description
      }

      function uploadFilesToJob(jobId) {
        let files = job.attachments
        let requests = []

        var fl = files.length;

        for (var i = 0; i < fl; i++) {
          buildRequests(i)
        }

        function buildRequests(i) {
          let formData = new FormData()
          let apiData = JSON.stringify(SS.API.V3.build.attachment({jobId: jobId}))

          formData.append('attachment', apiData)
          formData.delete && formData.delete('file') // doesn't exist on safari mobile
          formData.append('file', files[i])

          let request = SS.API.V3.attachment({data: formData})
          request.beforeSend = () => {
            $('.status-message').text(`Uploading ${files[i].name}...`)
          }
          requests.push(request)
        }

        var slideTo = '';
        let closureData = Job.Data.closureSurvey;

        if(closureData.job && typeof closureData.job.id !== 'undefined') {
          slideTo = JobWizardMobile.HasJobBeenDoneYet;
        }

        function processUploads(index) {
          if (index < requests.length) {
            $.ajax(requests[index])
            .always(() => {
              processUploads(index + 1)
            })
            .fail(() => {
              setAttachmentError()
            })
          } else {
            $('.status-message').text("All Done!")
            slideTo === '' ? redirectToJobPage() : JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', slideTo)
          }
        }

        processUploads(0)
      }

      function setAttachmentError(){
        Cookies.set('job-attachment-error', Job.Data.id)
      }

      function redirectToJobPage() {

        var message = JSON.stringify({message_type: 'jobs_wizard', message: 'JOB_POSTING_COMPLETED', payload: Job.Data.id})

        if (JobWizardMobile.MessageChannel.sendMessage(message) == true) {
          return;
        }

        document.location.href = redirectUrl()

        function redirectUrl() {
          let jobID = Job.Data.id

          switch (Job.Data.referrer.cta) {
            case 'profile': {
              return `/jobs/${jobID}/profilejob?successful_job=true`
            }
            case 'business_directory_card': {
              return `/jobs/${jobID}/bcardjob?successful_job=true`
            }
            default: {
              return `/jobs/${jobID}/posted?successful_job=true`
            }
          }
        }
      }
    },

    render: function() {
      return (
        <div className="modal-body job-form-body">
          <h3>
            Saving your job details
          </h3>
          <p>
            <i className="status-message"></i>
            <div className="spinner-icon text-center" style={{marginLeft: '15px'}}/>
          </p>
        </div>
      )
    }
  })
}
